import React from 'react'
import {findDOMNode} from "react-dom"

import {LayoutMenuState} from "../layout/const"
import {UIType} from "../ui/@const";

type Props = {
    className?  : string
    navType     : 'left' | 'top'
    children    : any
}

// const debug = "UICenter"
const debug = false

export default class UICenter extends React.Component<Props> {

    componentDidMount() {
    }

    componentWillUnmount() {
        gd.bus.unsubscribe(this)
    }

    onResizeMenu = (value:number, percentValue?:number) => {
        const styles = this.getStyles(value)

        const node: any = findDOMNode(this)


        if (styles.left) {
            node.style.setProperty("left", styles.left)
        } else {
            node.style.removeProperty("left")
        }

        if (styles.width) {
            node.style.setProperty("width", styles.width)
        } else {
            node.style.removeProperty("width")
        }
    }

    getClasses = () => {

        let navClass
        switch(gd.ui.type) {
            case UIType.TOP:
                navClass = 'nav-top'
                break
            default:
                navClass = 'nav-left'
        }

        let centerClass = gd.ui.uiCenterMainClass

        return Classes(centerClass, navClass, this.props.className, {
            'menu-closed': gd.layout.isMenuHiddenForCurrentApp,
            'left-border-radius' : gd.layout.isMenuHiddenForCurrentApp || gd.layout.menuState !== LayoutMenuState.STATIC  // Set left border radius for center block dynamically. For Click up skin
        })
    }

    getStyles = (menuWidth:number) => {

        if (gd.ui.isMinimizeMenuAllowed) {
            if (gd.layout.localSettings.forcedMin ||
                gd.layout.shouldHideMenuBecauseOfScreenSize ||
                gd.layout.isMenuHiddenForCurrentApp) {
                menuWidth = 0
            }
        }

        if (gd.layout.shouldHideMenuBecauseOfScreenSize) {
            menuWidth = 0
        }

        // let uiCenterLeft = menuWidth + gd.ui.leftNavigationPanelSize
        let uiCenterLeft = menuWidth + gd.ui.uiCenterLeftSpace

        let uiCenterWidthDifference = menuWidth + gd.ui.uiCenterLeftSideDifference

        return {
            left    : "{0}px".f(uiCenterLeft),
            width   : "calc(100% - {0}px)".f(uiCenterWidthDifference)
        }
    }

    render() {
        const classes   = this.getClasses()
        const styles    = this.getStyles(gd.layout.localSettings.menuWidth)

        debug && console.log(debug, 'render', classes, styles)

        return (
            <div id="ui-main-center" className={classes} style={styles}>
                {this.props.children}
            </div>
        )
    }
}
